import { styled } from 'linaria/react';
import { media } from '../../../../../media';
import { css } from 'linaria';

export const StyledDiv = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 32px;
	margin-top: 40px;
	${media.mobile} {
		grid-template-columns: 1fr;
		gap: 16px;
	}
`;

export const allServicesCardStyles = css`
	max-width: 100%;
`;
